module.exports = __webpack_public_path__ + "static/media/sz.05258322.svg";